import sanitizeHtml from 'sanitize-html'

const svgAllowed = [
  'svg',
  'g',
  'path',
  'circle',
  'rect',
  'line',
  'polyline',
  'polygon',
  'ellipse',
  'defs',
  'clipPath',
  'title',
  'desc',
  'use',
  'linearGradient',
  'stop',
]

const customAttrs = {
  '*': ['class'],
  'a': ['rel'],
  'svg': ['xmlns', 'width', 'height', 'viewBox'],
  'path': ['d', 'fill', 'stroke', 'stroke-width'],
  'circle': ['cx', 'cy', 'r', 'fill', 'stroke'],
  'rect': ['x', 'y', 'width', 'height', 'rx', 'ry', 'fill', 'stroke'],
  'line': ['x1', 'y1', 'x2', 'y2', 'stroke'],
  'polygon': ['points', 'fill', 'stroke'],
  'polyline': ['points', 'fill', 'stroke'],
  'ellipse': ['cx', 'cy', 'rx', 'ry', 'fill', 'stroke'],
  'use': ['href', 'xlink:href'],
  'linearGradient': ['id', 'x1', 'y1', 'x2', 'y2'],
  'stop': ['offset', 'stop-color', 'stop-opacity'],
}

export function sanitizeHTML(input: string) {
  return sanitizeHtml(input, {
    allowedTags: sanitizeHtml.defaults.allowedTags.concat(svgAllowed),
    allowedAttributes: {
      ...sanitizeHtml.defaults.allowedAttributes,
      ...Object.fromEntries(
        Object.entries(customAttrs).map(([tag, attrs]) => [
          tag,
          [...(sanitizeHtml.defaults.allowedAttributes[tag] || []), ...attrs],
        ]),
      ),
    },
    allowedSchemes: ['http', 'https', 'data'],
  })
}
